import data from "../../utils/constants/data.json";
import CommonComponent from "../common-component/CommonComponent";

const AboutComponent = () => {
    const { aboutData } = data;

    const aboutLayout = <CommonComponent items={aboutData} />;

    return aboutLayout;
};

export default AboutComponent;
